<ng-template #mPopup  class="policy_doc_invest-popup">
    <!-- <div style="position: absolute; right: 15px; top: 15px; color: black;z-index: 9999999999;">
        <nb-icon class="closeIcon" icon="close-outline" (click)="closeWindow();"></nb-icon>
    </div> -->
    <div class="popup_t3_container" [style.max-width]="maxWidth ? maxWidth : null" style="text-align: center;">
        <!-- content -->
        <ng-content  select="[contentMain]"  ></ng-content>
        <div class="popupContent" *ngIf="headerImage && !isMobile" [style.width]="width ? width : null" [style.height]="height ? height : null">
            <div class="headerImage">
                <img [src]="headerImage" />
            </div>
    
            <div class="space"></div>
            <div class="contentHeaderCenter" *ngIf=contentHeader>
                {{contentHeader}}
            </div>
            <div class="space"></div>
    
            <div class="contentTextCenter" *ngIf=contentText>
                {{contentText}}
            </div>
            <div class="contentCenter">
                {{content}}
            </div>
            <div class="space"></div>
            <img *ngIf="contentImage" [src]="contentImage" style="width:70%; height:70%; margin:auto; padding:2%">
            <div class="showAgainCheckBox">
                <ng-content  select="[showAgainCheckBox]"></ng-content>
            </div>
        </div>
    
        <div class="popupButton" *ngIf="headerImage && buttonText">
            <button class="vButton" (click)="nextClick()" appListButton>{{buttonText}}</button>
        </div>
    
    
        <div *ngIf="isMobile" class="mobileContainer">
            <div *ngIf="headerTemplate" class="headerButtonTemplate">
                <div class="popupContainer">
                    <div class="headerImage" *ngIf="headerImageSrc">
                        <img [src]="headerImageSrc"  />
                    </div>
                    <div class="headerImage" *ngIf="headerImage">
                        <img [src]="headerImage"  />
                    </div>
                    <div class="popupContent">
                        <div *ngIf="content" class="contentCenter">
                            {{content}}
                        </div>
                        <ng-content  select="[contentCenter]"></ng-content>
                        <ng-content  select="[showAgainCheckBox]"></ng-content>
    
                    </div>
                    
                    <div  *ngIf="buttonText" class="popUpFooter" style="height: 120px;
                    background-color: #E98126;
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    line-height: 120px;
                    font-size: 24px;
                    color: white;
                    align-self: stretch;"
                        [innerHTML]="buttonText" (click)="nextClick()">
                    </div>
                </div>   
            </div>
            <div *ngIf="! headerTemplate && buttonText" class="headerButtonTemplate">
                <div class="popupContainer">
                    <div style="flex: 1 1 auto;">
                        <ng-content  select="[contentCenter2]"></ng-content>
                    </div>
    
                    <div class="popUpFooter" style="height: 100px;
                    background-color: #E98126;
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    line-height: 10px;
                    font-size: 24px;
                    color: white;
                    display:flex;
                    justify-content:center;
                    align-items: center;"
                        [innerHTML]="buttonText" (click)="nextClick()">
                    </div>
                </div>  
            </div>
            <ng-content *ngIf="! headerTemplate" ></ng-content>
        </div>
    </div>
    </ng-template>
    